import { useCallback } from 'react'
import { FormikHelpers } from 'formik'
import { message } from 'antd'
import { useParams } from 'react-router-dom'

import { FormOptions } from '@shared/modules/form/types'

import { ProductCategoriesService } from '../services/categories'
import { ProductCategoryFormData } from '../types/categories'
import { useProductCategoryInitialValues } from './use-category-initial-values'
import { useBackgroundNavigate } from '@shared/hooks/use-background-navigate'

export const useProductCategoryForm = ({ type = 'create', redirectUrl }: FormOptions) => {
  const params = useParams<{ id?: string }>()
  const navigate = useBackgroundNavigate()

  const initialValues = useProductCategoryInitialValues(params.id)

  const onSubmit = useCallback(
    async (values: ProductCategoryFormData, helpers: FormikHelpers<ProductCategoryFormData>) => {
      helpers.setStatus(null)
      const result = await ProductCategoriesService.createOrUpdate(values, type)

      if (result.status === 200) {
        if (redirectUrl) {
          navigate(redirectUrl)
        } else {
          helpers.resetForm()
        }
        message.success('Məlumatlar müvəffəqiyyətlə yeniləndi.')
      } else if (result.status === 422) {
        helpers.setErrors(result.data)
      } else {
        helpers.setStatus({ type: 'error', message: result.data })
      }
    },
    [navigate, redirectUrl, type],
  )

  return { initialValues, onSubmit }
}
